import React from 'react';
import { Accordion, Col, Card, Row } from 'react-bootstrap';

const FamilyGroupShow = ({ familyGroup }) => (
  <>
    <Row className="mt-3 mb-4">
      <Col xs={12} md={3}>
        <div className="d-flex flex-column mb-3">
          <span className="type">Tipo de Carga:</span>
          <span className={`answer ${!familyGroup.translatedChargeType ? 'text-grey' : ''}`}>
            {familyGroup.translatedChargeType || 'No Aplica'}
          </span>
        </div>
      </Col>
      <Col xs={12} md={3}>
        <div className="d-flex flex-column mb-3">
          <span className="type">Relación:</span>
          <span className={`answer ${!familyGroup.translatedRelationType ? 'text-grey' : ''}`}>
            {familyGroup.translatedRelationType || 'No Aplica'}
          </span>
        </div>
      </Col>
      <Col xs={12} md={3}>
        <div className="d-flex flex-column mb-3">
          <span className="type">Nombre y Apellido:</span>
          <span
            className={`answer ${
              ![familyGroup.name, familyGroup.firstLastName, familyGroup.secondLastName].filter(Boolean).length
                ? 'text-grey'
                : ''
            }`}
          >
            {[familyGroup.name, familyGroup.firstLastName, familyGroup.secondLastName].filter(Boolean).join(' ') ||
              'No Aplica'}
          </span>
        </div>
      </Col>
      {familyGroup.nationalIdentification && (
        <Col xs={12} md={3}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Identificación ({familyGroup.translatedIdentificationType}):</span>
            <span className={`answer ${!familyGroup.nationalIdentification ? 'text-grey' : ''}`}>
              {familyGroup.nationalIdentification || 'No Aplica'}
            </span>
          </div>
        </Col>
      )}
      {familyGroup.familyAllowanceSection && (
        <Col xs={12} md={3}>
          <div className="d-flex flex-column mb-3">
            <span className="type">Tramo Asignación Familiar:</span>
            <span
              className={`answer ${
                !(familyGroup.translatedFamilyAllowanceSection || familyGroup.familyAllowanceSection) ? 'text-grey' : ''
              }`}
            >
              {familyGroup.translatedFamilyAllowanceSection || familyGroup.familyAllowanceSection || 'No Aplica'}
            </span>
          </div>
        </Col>
      )}
    </Row>

    <Row className="mt-3 mb-4">
      <Col xs={12} md={3}>
        {familyGroup.countryId && (
          <div className="d-flex flex-column mb-3">
            <span className="type">Nacionalidad:</span>
            <span className={`answer ${!familyGroup.country?.label ? 'text-grey' : ''}`}>
              {familyGroup.country?.label || 'No Aplica'}
            </span>
          </div>
        )}
      </Col>
      <Col xs={12} md={3}>
        {familyGroup.birthdate && (
          <div className="d-flex flex-column mb-3">
            <span className="type">Fecha de Nacimiento:</span>
            <span className={`answer ${!familyGroup.birthdate ? 'text-grey' : ''}`}>
              {familyGroup.birthdate || 'No Aplica'}
            </span>
          </div>
        )}
      </Col>
      <Col xs={12} md={3}>
        {familyGroup.genderId && (
          <div className="d-flex flex-column mb-3">
            <span className="type">Género:</span>
            <span className={`answer ${!familyGroup.gender?.label ? 'text-grey' : ''}`}>
              {familyGroup.gender?.label || 'No Aplica'}
            </span>
          </div>
        )}
      </Col>
      <Col xs={12} md={3}>
        {familyGroup.chargeStartDate && (
          <div className="d-flex flex-column mb-3">
            <span className="type">Fecha de Inicio:</span>
            <span className={`answer ${!familyGroup.chargeStartDate ? 'text-grey' : ''}`}>
              {familyGroup.chargeStartDate || 'No Aplica'}
            </span>
          </div>
        )}
      </Col>
    </Row>

    <Row className="mt-3 mb-4">
      <Col xs={12} md={3}>
        {familyGroup.chargeEndDate && (
          <div className="d-flex flex-column mb-3">
            <span className="type">Fecha Término:</span>
            <span className={`answer ${!familyGroup.chargeEndDate ? 'text-grey' : ''}`}>
              {familyGroup.chargeEndDate || 'No Aplica'}
            </span>
          </div>
        )}
      </Col>
    </Row>
    {familyGroup.observation && (
      <Row className="mt-3 mb-4">
        <Col xs={12} className="col-md-12">
          <div className="d-flex flex-column mb-3">
            <span className="type">Observación:</span>
            <span className={`answer ${!familyGroup.observation ? 'text-grey' : ''}`}>
              {familyGroup.observation || 'No Aplica'}
            </span>
          </div>
        </Col>
      </Row>
    )}
  </>
);

const FamilyGroupInfo = ({ familyGroupsAttributes = [], activeKey, activeAccordion }) => {
  return (
    <Card className="mr-2">
      <Col className={`${activeKey === 'family-group' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
        <Accordion.Toggle as={Col} eventKey="4" onClick={activeAccordion} className="card-header-title">
          Grupo Familiar
        </Accordion.Toggle>
      </Col>
      <Accordion.Collapse eventKey="4">
        <Card.Body className="personal-data">
          {familyGroupsAttributes.length > 0 ? (
            familyGroupsAttributes.map((familyGroup, index) => (
              <React.Fragment key={`family_group_${familyGroup.id || index}`}>
                {index > 0 && <hr className="my-3" />}
                <FamilyGroupShow familyGroup={familyGroup} />
              </React.Fragment>
            ))
          ) : (
            <div className="text-center py-3">No hay información de grupo familiar registrada</div>
          )}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

export default FamilyGroupInfo;
